import { ref } from 'vue';
import { Blog } from './blog.type';
export function useGetBlogs() {
    const blogs = ref();
    const fetchBlogs = () => {
        blogs.value = [
            Blog.from({ title: 'Blog 01', description: 'This is description 01' }),
            Blog.from({ title: 'Blog 02', description: 'This is description 02' }),
            Blog.from({ title: 'Blog 03', description: 'This is description 03' }),
            Blog.from({ title: 'Blog 04', description: 'This is description 04' }),
            Blog.from({ title: 'Blog 05', description: 'This is description 05' }),
            Blog.from({ title: 'Blog 06', description: 'This is description 06' }),
        ];
    };
    fetchBlogs();
    return blogs;
}
//# sourceMappingURL=blogs.js.map